import React, { Component } from 'react';
import ReactGA from 'react-ga4';
import './App.css';
import Header from './Components/Header';
import Footer from './Components/Footer';
import About from './Components/About';
import Resume from './Components/Resume';
import Testimonials from './Components/Testimonials';

class App extends Component {

  constructor(props){
    super(props);
    this.state = {
      foo: 'bar',
      resumeData: {}
    };

    // GA4 measurement ID, e.g. G-XXXXXXXXXX. Analytics stays off when unset.
    const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
    if (measurementId) {
      ReactGA.initialize(measurementId);
      ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
    }

  }

  getResumeData(){
    fetch(`${process.env.PUBLIC_URL}/resumeData.json`, { cache: 'no-cache' })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Failed to load resumeData.json: ${response.status}`);
        }
        return response.json();
      })
      .then(data => this.setState({ resumeData: data }))
      .catch(err => console.error(err));
  }

  componentDidMount(){
    this.getResumeData();
  }

  render() {
    return (
      <div className="App">
        <Header data={this.state.resumeData.main}/>
        <About data={this.state.resumeData.main}/>
        <Resume data={this.state.resumeData.resume}/>
        <Testimonials data={this.state.resumeData.testimonials}/>
        <Footer data={this.state.resumeData.main}/>
      </div>
    );
  }
}

export default App;